import React, { Component, useState, useMemo, useEffect, useRef } from "react";
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Grid } from '@mui/material';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import OrderFiles from '../components/OrderFiles'
import { CommentsTabs, commentsList, productFilesTypeToInfo } from '../pages/Orders'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { useReactToPrint } from "react-to-print";
import Barcode from 'react-barcode';
import TabsInput from "../components/TabsInput";
import config from '../config/default.json';
import { SquareCheck, SquareX } from 'tabler-icons-react';


function orderStatusToInfo(status) {
    switch (parseInt(status)) {
        case 0:
            return (<span style={{ color: "green" }}>Nowe</span>)
        case 1:
            return (<span style={{ color: "blue" }}>Produkcja</span>)
        case 3:
            return (<span style={{ color: "red" }}>Anulowane</span>)
        case 4:
            return (<span style={{ color: "purple" }}>Archiwum</span>)
        case 5:
            return (<span style={{ color: "black" }}>Odebrane</span>)
        default:
            return (<span style={{ color: "red" }}>Nieobsługiwany kod statusu</span>)
    }
}

function techCardStatusToInfo(status) {
    switch (Boolean(status)) {
        case false:
            return (<span style={{ color: "red" }}>Nie wydrukowana</span>)
        case true:
            return (<span style={{ color: "green" }}>Wydrukowana</span>)
        default:
            return (<span style={{ color: "red" }}>Nieobsługiwany kod statusu</span>)
    }
}

export default function OrderManage(props) {
    const { orderId } = useParams();
    const [order, setOrder] = useState(undefined);

    useEffect(() => {
        if (!orderId) throw ('Provide order id');
        query(`/orders/?id=${orderId}`, 'GET', undefined, false)
            .then(res => setOrder(res))
    }, [orderId])

    async function changeStatusButtonHandler(status) {
        await query(`/orders/changeStatus/${status}/${orderId}`, 'PATCH')
        window.location.reload();
    }
    return (
        !order ?
            <CircularProgress /> : (
                <Grid xs={12} item container >
                    <Grid xs={12} item container className="container" sx={{ marginBottom: "20px" }}>
                        <Grid xs={12} item>
                            <Typography variant="h5">
                                Obecny status: {orderStatusToInfo(order.status)}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" textAlign="left">
                                Zmien status na:
                            </Typography>
                        </Grid>
                        <Grid item sx={{
                            "&>button": {
                                marginLeft: "10px"
                            }
                        }}>
                            {
                                order.status != 0 && <Button variant="contained" color="success" onClick={() => changeStatusButtonHandler(0)}>Nowe</Button>
                            }
                            {
                                order.status != 1 && <Button variant="contained" onClick={() => changeStatusButtonHandler(1)}>Produkcja</Button>
                            }
                        </Grid>
                    </Grid>
                    <OrderFiles order={order} />
                    <Grid xs={12} item container className="container" sx={{ marginBottom: "20px" }}>
                        <Typography variant="h6" textAlign="left">
                            Komentarze
                        </Typography>
                        <CommentsTabs disableEdit={true} data={order["comments"]} />
                    </Grid>
                    <Grid xs={12} item container sx={{ marginBottom: "20px" }} spacing={3}>
                        <Grid xs={6} item>
                            <Box className="container">
                                <Typography variant="h6" textAlign="left">
                                    Pliki
                                </Typography>
                                {
                                    (order.files && order.files.attachmentPath) && (
                                        <Link to={`${config.apiPath}${order.files.attachmentPath}`} target="_blank" download>
                                            {
                                                order.files.attachmentPath.split('/')[order.files.attachmentPath.split('/').length - 1]
                                            }
                                        </Link>
                                    )
                                }
                            </Box>
                        </Grid>
                        <Grid xs={6} item >
                            <Box className="container">
                                <Typography variant="h6" textAlign="left">
                                    Wiadomosc od klienta
                                </Typography>
                                {
                                    (order.files && order.files.clientAttachmentsPath) && (
                                        <Link to={`${config.apiPath}${order.files.clientAttachmentsPath}`} target="_blank" download>
                                            {
                                                order.files.clientAttachmentsPath.split('/')[order.files.clientAttachmentsPath.split('/').length - 1]
                                            }
                                        </Link>
                                    )
                                }
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid xs={12} item className="container">
                        <Typography variant="h6" textAlign="left">
                            Karta obiegowa
                        </Typography>
                        <TabsInput>
                            {order.products.map((e, index) => {
                                return <Grid xs={12} item className="container"
                                    index={index} tablabel={"Produkt " + e.id} key={"techCard." + index}>
                                    <Typography textAlign={"center"}>
                                        <Typography variant="h5" textAlign={"center"} sx={{ marginBottom: "10px" }}>
                                            {techCardStatusToInfo(order.products[index]['tech_card_printed'])}
                                        </Typography>
                                        <Button variant="contained" sx={{ marginBottom: "10px" }} size="large" onClick={() => {
                                            window.open(`https://produkcja.patentdruk.pl/kartaTech.php?orderId=${orderId}&productId=${e.id}`, '_blank')
                                        }}>Drukuj Technologiczna</Button>
                                        <PrintTechCard orderData={order} productData={order.products[index]} />
                                    </Typography>
                                </Grid>
                            })
                            }
                        </TabsInput>
                    </Grid>
                </Grid>
            ));
}
function PrintTechCard(props) {
    let componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => {
            window.location.reload();
        }
    });
    return (
        <>
            <div>
                {/* button to trigger printing of target component */}
                <Button variant="contained" sx={{ marginBottom: "10px" }} onClick={async () => {
                    await query(`/orders/${props.orderData["_id"]}/product/${props.productData["id"]}/printTechCard`, 'POST');
                    handlePrint();
                }} size="large">Drukuj Obiegowa</Button>
                {/* component to be printed */}
                <ComponentToPrint {...props} ref={componentRef} />
            </div>
        </>
    );
}

const ComponentToPrint = React.forwardRef((props, ref) => {
    console.log(props.orderData)
    return (
        <div ref={ref} style={{ margin: "40px" }}>
            <table width="100%">
                <tbody>
                    <tr>
                        <td rowspan="2" width="33%"><Barcode value={`${props.orderData["_id"]},${props.productData["id"]}`} width={1} fontSize={12} /></td>
                        {props.productData.fsc ? <td rowspan="2" ><svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" viewBox="0 0 166.84 200"><path fill="#231F20" d="M97.631.735c-40.224 0-54.418 62.313-67.641 112.439-4.783-4.82-19.502-19.458-19.517-19.434-2.96-2.924-6.36-1.973-8.443.053-2.096 2.105-2.402 5.965 0 8.307.121.104 19.944 19.813 26.795 26.645 1.89 1.834 4.625 2.914 7.358 1.322 2.832-1.738 3.22-4.809 3.297-4.809C62.965 20.336 83.953 12.512 97.576 12.512c11.46 0 24.667 8.439 24.667 25.321 17.09 0 27.801 22.391 14.047 36.174 11.403 5.501 16.489 12.266 16.489 20.826 0 8.569-7.196 17.317-17.7 17.294-10.416 0-15.709-6.674-23.824-6.703-3.68 0-5.912 2.965-5.912 5.889v21.183H90.021v-21.104c-.043-3.307-2.484-5.908-5.525-5.908-.049 0-1.311.037-1.292.08l-20.521 2.521c-2.475.373-4.761 3.053-4.761 5.82 0 3.244 2.666 5.938 6.302 5.893.463 0 1.085 0 1.024-.053-.037 0 12.99-1.65 12.99-1.65v20.908c0 2.645 3.009 5.24 5.713 5.24h27.261c3.17 0 5.925-2.729 5.925-5.932v-19.094c5.704 3.469 13.639 4.812 17.709 4.812 15.293 0 29.879-11.983 29.836-29.563-.06-15.935-12.293-23.894-12.293-23.894 7.18-19.062-4.433-37.465-19.472-42.583C127.495 8.327 110.65.735 97.631.735" /><path fill="#231F20" d="M97.631.735c-40.224 0-54.418 62.313-67.641 112.439-4.783-4.82-19.502-19.458-19.517-19.434-2.96-2.924-6.36-1.973-8.443.053-2.096 2.105-2.402 5.965 0 8.307.121.104 19.944 19.813 26.795 26.645 1.89 1.834 4.625 2.914 7.358 1.322 2.832-1.738 3.22-4.809 3.297-4.809C62.965 20.336 83.953 12.512 97.576 12.512c11.46 0 24.667 8.439 24.667 25.321 17.09 0 27.801 22.391 14.047 36.174 11.403 5.501 16.489 12.266 16.489 20.826 0 8.569-7.196 17.317-17.7 17.294-10.416 0-15.709-6.674-23.824-6.703-3.68 0-5.912 2.965-5.912 5.889v21.183H90.021v-21.104c-.043-3.307-2.484-5.908-5.525-5.908-.049 0-1.311.037-1.292.08l-20.521 2.521c-2.475.373-4.761 3.053-4.761 5.82 0 3.244 2.666 5.938 6.302 5.893.463 0 1.085 0 1.024-.053-.037 0 12.99-1.65 12.99-1.65v20.908c0 2.645 3.009 5.24 5.713 5.24h27.261c3.17 0 5.925-2.729 5.925-5.932v-19.094c5.704 3.469 13.639 4.812 17.709 4.812 15.293 0 29.879-11.983 29.836-29.563-.06-15.935-12.293-23.894-12.293-23.894 7.18-19.062-4.433-37.465-19.472-42.583C127.495 8.327 110.65.735 97.631.735M80.462 167.559c0 4.926 5.513 7.898 14.597 12.205 7.205 3.359 11.349 6.92 11.349 9.783 0 4.627-4.988 6.266-9.665 6.266-7.235 0-11.506-2.875-13.875-9.328l-.207-.545h-.584c-1.271 0-2.284.06-2.848.744-.503.662-.361 1.529-.155 2.373-.016-.02 1.598 6.617 1.598 6.617.431 1.613 1.014 1.875 3.599 2.383 1.133.195 6.983 1.207 11.939 1.207 13.823 0 19.993-5.598 19.993-11.154 0-4.045-4.017-7.91-12.683-12.227l-3.937-1.893c-5.929-2.816-9.521-4.49-9.521-7.461 0-2.877 3.719-4.879 9.024-4.879 6.929 0 8.776 3.859 9.625 7.219l.149.631h.656c1.541 0 2.515-.127 3.084-.746.332-.352.467-.838.387-1.406l-.54-5.732c-.152-1.846-1.558-2.11-3.511-2.506-2.324-.412-5.102-.916-9.299-.916-12.008-.001-19.175 3.507-19.175 9.365M120.275 179.162c0 9.979 8.681 20.102 25.308 20.102 8.377 0 13.084-1.916 16.599-3.777l.946-.498-1.532-1.711.084.086c-.371-.51-.66-.612-1.224-.612l-.808.278c-1.26.582-5.104 2.359-12.08 2.359-8.598 0-17.848-5.588-17.848-17.895 0-11.707 10.041-15.844 18.598-15.844 6.168 0 9.447 2.191 10.058 6.732l.069.741h.767c.733 0 2.683 0 2.683-1.457v-6.821c0-1.683-1.933-1.912-2.738-2.033l-.805-.115c-1.972-.256-3.863-.504-8.867-.504-16.93 0-29.21 8.821-29.21 20.969M57.652 158.686l-14.97.121-9.975-.164-1.517-.035c-.889 0-1.528.638-1.528 1.56 0 .425 0 1.767 1.652 1.767 6.029 0 6.251.483 6.306 2.789l.058 1.451.094 6.148v13.23c0 2.188-.079 5.678-.222 8.489-.04.813-.081 1.578-5.404 1.578-1.51 0-2.402.304-2.402 1.761 0 .436 0 1.559 1.447 1.559h.334c.636-.031 2.323-.109 10.654-.109 8.874 0 10.654.092 11.258.109h.312c1.165 0 2.178-.109 2.178-1.559 0-1.625-1.346-1.761-3.597-1.761-5.347 0-5.39-.765-5.429-1.562-.127-2.582-.236-6.07-.236-8.508v-4.775h4.486c6.863 0 7.624.195 8.607 5.465.282 1.148 1.2 1.293 1.965 1.293 1.614 0 1.79-.879 1.79-1.27l-.136-1.98a41.738 41.738 0 0 1-.225-4.452v-8.108c0-1.215-1.468-1.215-2.251-1.215-1.294 0-1.595.819-2.417 4.653-.379 1.454-3.212 2.299-7.773 2.299h-4.046v-11.907c0-3.244.574-3.27 1.289-3.279 2.626-.121 8.986-.34 10.898-.34 1.819 0 3.493.416 4.561 1.121 3.403 2.098 5.141 3.528 6.196 4.391 1.032.824 1.61 1.311 2.448 1.311.498 0 1.941 0 1.941-1.248 0-.305-.137-.584-.601-1.615-.549-1.225-1.483-3.231-2.666-6.318-.343-.982-1.465-.982-3.564-.982l-9.515.092zM152.573 12.794h2.114c.967 0 1.638-.158 2.027-.431.373-.279.564-.676.564-1.197 0-.492-.191-.889-.543-1.171-.357-.273-1.082-.428-2.178-.428h-1.986l.002 3.227zm7.305 6.023h-2.127c-1.33-2.417-2.217-3.773-2.61-4.091-.414-.304-.916-.452-1.537-.452h-1.029v4.543h-1.738V8.123h3.725c1.109 0 1.947.08 2.556.252.598.139 1.086.473 1.459.989.375.497.569 1.067.569 1.652 0 .731-.266 1.386-.807 1.987-.525.601-1.277.935-2.27 1.013v.03c.631.158 1.477 1.053 2.49 2.691l1.319 2.08zm-4.678 2.806c2.291 0 4.241-.8 5.87-2.432 1.63-1.635 2.462-3.585 2.476-5.89 0-2.284-.819-4.24-2.45-5.854-1.638-1.614-3.604-2.44-5.896-2.44-2.293 0-4.267.812-5.877 2.426-1.628 1.628-2.435 3.584-2.447 5.868 0 2.29.819 4.255 2.433 5.875 1.627 1.627 3.584 2.447 5.891 2.447m.041-18.261c2.717 0 5.053.967 7.01 2.899 1.974 1.956 2.949 4.304 2.949 7.039 0 2.742-.978 5.089-2.925 7.036-1.952 1.941-4.297 2.923-7.034 2.923-2.761 0-5.128-.958-7.07-2.898-1.974-1.956-2.948-4.305-2.948-7.061 0-2.735.977-5.068 2.948-7.024 1.942-1.947 4.309-2.914 7.07-2.914" /><path fill="#231F20" d="M155.243 23.782c-2.912 0-5.416-1.029-7.449-3.062-2.058-2.035-3.092-4.528-3.092-7.418 0-2.869 1.034-5.356 3.092-7.388 2.047-2.044 4.554-3.088 7.449-3.088 2.838 0 5.332 1.038 7.391 3.069 2.062 2.035 3.093 4.521 3.093 7.406 0 2.875-1.025 5.362-3.078 7.395-2.042 2.049-4.542 3.086-7.406 3.086m0-19.899c-2.601 0-4.856.929-6.703 2.774-1.875 1.862-2.795 4.031-2.795 6.643 0 2.632.92 4.815 2.795 6.67 1.823 1.825 4.09 2.759 6.703 2.759 2.61 0 4.797-.904 6.661-2.775 1.837-1.838 2.771-4.067 2.771-6.654 0-2.586-.941-4.833-2.785-6.663-1.85-1.831-4.092-2.754-6.647-2.754" /><path fill="#231F20" d="M155.206 22.154c-2.42 0-4.526-.874-6.267-2.603-1.723-1.724-2.598-3.828-2.598-6.251.021-2.442.898-4.537 2.613-6.245 1.707-1.704 3.809-2.578 6.25-2.578 2.418 0 4.525.874 6.262 2.592 1.736 1.708 2.611 3.813 2.611 6.23-.014 2.43-.898 4.534-2.635 6.266-1.712 1.724-3.818 2.589-6.236 2.589m0-16.624c-2.147 0-3.996.771-5.498 2.275-1.543 1.528-2.283 3.32-2.301 5.501 0 2.129.766 3.983 2.282 5.496 1.549 1.543 3.354 2.299 5.517 2.299 2.164 0 3.955-.75 5.498-2.29 1.541-1.538 2.299-3.345 2.323-5.52 0-2.151-.762-3.943-2.299-5.478-1.533-1.512-3.393-2.283-5.522-2.283" /><path fill="#231F20" d="M160.835 19.338h-3.392l-.151-.273c-1.826-3.312-2.379-3.857-2.476-3.933-.301-.212-.707-.336-1.209-.336h-.51v4.542h-2.791V7.596h4.252c1.213 0 2.068.084 2.697.254.707.183 1.301.58 1.75 1.195.439.598.66 1.261.66 1.962 0 .874-.318 1.663-.943 2.348-.356.412-.812.716-1.358.925.502.485 1.041 1.201 1.651 2.175l1.82 2.883zm-2.773-1.052h.853l-.801-1.27c-1.302-2.102-1.99-2.409-2.162-2.445l-.283-.062c.513.551 1.304 1.815 2.393 3.777m-6.703 0h.687v-4.543h1.563c.721 0 1.352.188 1.848.556a.623.623 0 0 1 .086.068v-.803l.486-.085c.854-.063 1.477-.336 1.906-.828.465-.506.684-1.034.684-1.644 0-.466-.16-.928-.465-1.34s-.689-.67-1.168-.785c-.539-.164-1.322-.233-2.426-.233h-3.199v9.637h-.002z" /><path fill="#231F20" d="M154.693 13.315h-2.645V9.037h2.514c1.213 0 2.025.179 2.498.545.494.382.75.935.75 1.584 0 .685-.264 1.231-.772 1.62-.502.365-1.27.529-2.345.529m-1.589-1.051h1.592c1.043 0 1.514-.188 1.723-.337.229-.179.344-.412.344-.761a.945.945 0 0 0-.344-.759c-.1-.069-.52-.317-1.854-.317h-1.461v2.174z" /></svg></td> : ""}
                        <td width="33%" style={{ backgroundColor: "lightgrey", fontWeight: "bolder", textAlign: "center" }}>Zamówienie id:</td>
                        <td rowspan="2" width="33%" style={{ backgroundColor: "lightgrey" }}>
                            {
                                [{
                                    left: "Data odbioru",
                                    right: props.orderData.transport.completion_date
                                },
                                {
                                    left: "Firma",
                                    right: props.orderData.client.invoice.company
                                },
                                {
                                    left: "Handlowiec",
                                    right: `${props.orderData.trader.name} ${props.orderData.trader.surname}`
                                },
                                {
                                    left: "Id uzytkownika:",
                                    right: props.orderData.client["_id"]
                                }].map(e => <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}><div>{e.left}</div><div>{e.right}</div></div>)
                            }
                        </td>
                    </tr>
                    <tr>
                        <td style={{ backgroundColor: "lightgrey", fontWeight: "bolder", textAlign: "center" }}>{props.orderData["_id"]}</td>
                    </tr>
                </tbody>
            </table>
            <table width="100%" style={{ marginBottom: "20px" }}>
                <thead style={{ backgroundColor: "black", color: "white" }}>
                    <tr>
                        <td>
                            ID
                        </td>
                        <td>
                            Produkt
                        </td>
                        <td>
                            Nakład
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontWeight: "bolder" }}>
                            {props.productData["id"]}
                        </td>
                        <td>
                            <div style={{ fontWeight: "bolder" }}>{props.productData.product_name}</div>
                            <div style={{ fontSize: "14px" }}>(Kalkulacja:{props.productData.calculation_number})</div>
                        </td>
                        <td style={{ fontWeight: "bolder" }}>
                            {props.productData.quantity} szt.
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} style={{ borderTop: "solid black 1px", whiteSpace: "pre-line", textAlign: "left" }}>
                            {console.log(props.productData.description)}{props.productData.description}</td>
                    </tr>
                </tbody>
            </table>
            {
                commentsList.map(e => props.orderData.comments[e.name] && <table width="100%" style={{ marginBottom: "30px" }}>
                    <thead style={{ backgroundColor: "black", color: "white" }}>
                        <tr>
                            <td>
                                Komentarz {e.label}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {props.orderData.comments[e.name]}
                            </td>
                        </tr>
                    </tbody>
                </table>)
            }
            <table width="100%" style={{ marginBottom: "30px" }}>
                <thead style={{ backgroundColor: "black", color: "white" }}>
                    <tr>
                        <td>
                            Pliki
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            Typ plików: {productFilesTypeToInfo(props.productData)} <br />
                            Uwagi/Link: {props.productData.files.info}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div >
    );
});